import { LineChart } from "@mui/x-charts";
import React from "react";

const AnnualIncome = () => {
  const uData = [29.42, 57.96, 15.96, 12.65, 7.29, 2.56, 5.53];
  const xLabels = ["2018", "2019", "2020", "2021", "2022", "2023", "2024"];
  return (
    <LineChart
      width={800}
      height={400}
      series={[{ data: uData, label: "Income in Millions [LKR]" }]}
      xAxis={[{ scaleType: "point", data: xLabels }]}
    />
  );
};

export default AnnualIncome;
